/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './institution.reducer';

export const InstitutionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const institutionEntity = useAppSelector(state => state.institution.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="institutionDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.institution.detail.title">Institution</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.institution.id">Id</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.id}</dd>
          <dt>
            <span id="institutionCode">
              <Translate contentKey="tinyMedicRestApp.institution.institutionCode">Institution Code</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.institutionCode}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.institution.name">Name</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.name}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.institution.code">Code</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.code}</dd>
          <dt>
            <span id="address">
              <Translate contentKey="tinyMedicRestApp.institution.address">Address</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.address}</dd>
          <dt>
            <span id="fax">
              <Translate contentKey="tinyMedicRestApp.institution.fax">Fax</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.fax}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.institution.email">Email</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.email}</dd>
          <dt>
            <span id="contactEmail">
              <Translate contentKey="tinyMedicRestApp.institution.contactEmail">Contact Email</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.contactEmail}</dd>
          <dt>
            <span id="phone">
              <Translate contentKey="tinyMedicRestApp.institution.phone">Phone</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.phone}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.institution.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.mobile}</dd>
          <dt>
            <span id="web">
              <Translate contentKey="tinyMedicRestApp.institution.web">Web</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.web}</dd>
          <dt>
            <span id="chequePrintingName">
              <Translate contentKey="tinyMedicRestApp.institution.chequePrintingName">Cheque Printing Name</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.chequePrintingName}</dd>
          <dt>
            <span id="institutionType">
              <Translate contentKey="tinyMedicRestApp.institution.institutionType">Institution Type</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.institutionType}</dd>
          <dt>
            <span id="pointOfIssueNo">
              <Translate contentKey="tinyMedicRestApp.institution.pointOfIssueNo">Point Of Issue No</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.pointOfIssueNo}</dd>
          <dt>
            <span id="descreption">
              <Translate contentKey="tinyMedicRestApp.institution.descreption">Descreption</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.descreption}</dd>
          <dt>
            <span id="inactive">
              <Translate contentKey="tinyMedicRestApp.institution.inactive">Inactive</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.inactive ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.institution.active">Active</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.institution.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {institutionEntity.microSec ? <TextFormat value={institutionEntity.microSec} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.institution.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {institutionEntity.timestampEntry ? (
              <TextFormat value={institutionEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.institution.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {institutionEntity.lastUpdated ? (
              <TextFormat value={institutionEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.institution.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{institutionEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.institution.institution">Institution</Translate>
          </dt>
          <dd>{institutionEntity.institution ? institutionEntity.institution.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/institution" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/institution/${institutionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default InstitutionDetail;
